import React from 'react';

import { trans, getResourcePath } from '@spotahome/soyuz/client';
import { IconWithText, Heading, Rating } from '@spotahome/ui-library';

import './Testimonials.scss';

const Testimonials = () => (
  <div className="wrapper">
    <Heading
      size="large"
      text={trans('home-checker.testimonials.title')}
      className="mb-xl"
    />

    <p className="testimonials__description">
      {trans('home-checker.testimonials.description')}
    </p>

    <div className="wrapper">
      <div className="three-cols">
        <div className="testimonial">
          <IconWithText
            title={`Marco, ${trans('home-checker.testimonial.first.title')}`}
            content={trans('home-checker.testimonial.first.content')}
            iconUrl={getResourcePath('/images/home-checker/testimonial_1.jpg')}
            theme="dark"
          />
          <Rating rating={5} />
        </div>
        <div className="testimonial">
          <IconWithText
            title={`Clothilde, ${trans(
              'home-checker.testimonial.second.title'
            )}`}
            content={trans('home-checker.testimonial.second.content')}
            iconUrl={getResourcePath('/images/home-checker/testimonial_2.jpg')}
            theme="dark"
          />
          <Rating rating={5} />
        </div>
        <div className="testimonial">
          <IconWithText
            title={`Alejandro, ${trans(
              'home-checker.testimonial.third.title'
            )}`}
            content={trans('home-checker.testimonial.third.content')}
            iconUrl={getResourcePath('/images/home-checker/testimonial_3.jpg')}
            theme="dark"
          />
          <Rating rating={5} />
        </div>
      </div>
    </div>
  </div>
);

export default Testimonials;
